import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntroBottomLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 959,
	height: 578,
	viewBox: "0 0 959 578",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M-848.49 0C551.14 219.03 739.82 403.79 958.64 1795.45H-848.49V0Z",
		fill: "#303651"
	})
});
export default SvgIntroBottomLeft;
